import React from 'react';
import cls from '@utils/css-select';

import styles from './styles.scss';
const cx = cls(styles);

interface ISectionProp {
	children: React.ReactNode;
	className?: string;
}

/**
 * Section
 */
export default function Section(props: ISectionProp) {
	const { children, className = '' } = props;
	return <section className={cx('section-block', className)}>{children}</section>;
}
